import { v4 as uuidv4 } from 'uuid';

// generate a device identifier
let _device_identifier = localStorage.getItem("device_identifier")
if (_device_identifier === null) {
    _device_identifier = uuidv4() + '-' + Date.now()
    localStorage.setItem("device_identifier", _device_identifier)
}

export const device_identifier = _device_identifier
